import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import Age from '@blade-sxp/portrait-center/pages/components/line-bars/age-trend/index.vue';
import Stay from '@blade-sxp/portrait-center/pages/components/line-bars/stay/index.vue';
import GenderTrend from '@blade-sxp/portrait-center/pages/components/line-bars/gender-trend/index.vue';
import Expression from '@blade-sxp/portrait-center/pages/components/line-bars/expression/index.vue';
import ReturnedCustomers from '@blade-sxp/portrait-center/pages/components/line-bars/returned-customers/index.vue';
let default_1 = class default_1 extends Vue {
    dates;
    zoneType;
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
default_1 = __decorate([
    Component({
        name: 'dougnuts',
        components: { Age, Stay, GenderTrend, Expression, 'returned-customers': ReturnedCustomers },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
